ready(qs('.modal-container'), () => {
    const $modalContainer = qs('.modal-container');
    const $modal = qs($modalContainer, '.modal');

    ael($modal, 'click', (e) => {
        e.preventDefault()
        if (e.target.closest('.close-modal')) {
            $modalContainer.classList.remove('visible');
        }
    })
})


// WEBPACK FOOTER //
// ./src/scripts/components/Modal.js